module.exports = __webpack_public_path__ + "sourcesanspro.c4f39c8cef7f1746da98.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/sourcesanspro/sourcesanspro.woff
// module id = ../../../../../src/fonts/sourcesanspro/sourcesanspro.woff
// module chunks = 2